import React, { useState } from 'react'
import GameOver from '../gameInfo/GameOver';
import ModalGameInfo from '../gameInfo/ModalGameInfo';

function Header() {
    const [show, setShow] = useState(false);
    const [showGameOver, setShowGameOver] = useState(false);

    const handleClose = () => setShow(false);
    const isModalShow = () => setShow(!show);

    const handleCloseGameOver = () => setShowGameOver(false);
    const isModalShowGameOver = () => setShowGameOver(!showGameOver);

    return (
        <div className="navbar navbar-container">
            <div className="navbar-content px-2">
                <div className="left-icons">
                    <button onClick={() => isModalShow()} type="button" className="button-icon" title="Instrucciones del juego" aria-label="Instrucciones del juego">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                        </svg>
                    </button>
                </div>
                <h1 className="title-game">
                    <span className="live-dot"></span>
                    <span>Stream<span className="title-accent">erle</span></span>
                </h1>
                <div className="right-icons">
                    <button onClick={() => isModalShowGameOver()} type="button" className="button-icon" title="Estadísticas" aria-label="Estadísticas">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-reception-4" viewBox="0 0 16 16">
                            <path d="M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-8zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z" />
                        </svg>
                    </button>
                </div>
            </div>
            <GameOver show={showGameOver} handleClose={handleCloseGameOver} />
            <ModalGameInfo show={show} handleClose={handleClose} />
        </div>
    )
}

export default Header
